import { render, staticRenderFns } from "./unsupported-browser.vue?vue&type=template&id=43184665&"
import script from "./unsupported-browser.vue?vue&type=script&lang=js&"
export * from "./unsupported-browser.vue?vue&type=script&lang=js&"
import style0 from "./unsupported-browser.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unsupported-browser.vue"
export default component.exports